export const NAMESPACE = 'billing-unified';
export const ROUTE_PARENT_SECTION = 'billing';
export const ROUTE_SECTION_BILLING_INFORMATION = 'billing-information';
export const ROUTE_SECTION_CANCEL = 'cancel-subscription';
export const ROUTE_SECTION_CHECKOUT = 'checkout';
export const ROUTE_SECTION_DETAILS = 'details';
export const ROUTE_SECTION_CHECKOUT_SUCCESS = 'checkout/success';
export const ROUTE_SECTION_INVOICES = 'invoices';
export const ROUTE_SECTION_PURCHASE = 'purchase';
export const ROUTE_SECTION_USAGE_DETAILS = 'usage-details';
export const ROUTE_EMAIL_SUPPORT = 'email-support';

export const COUNTRIES_ZIP_MANDATORY = ['US', 'CA'];

export const DEFAULT_CURRENCY = 'USD';
export const CONFIG_STORAGE_KEY = `${NAMESPACE}/purchase_config`;

export const RECURLY_JS_CONFIGURATION = {
  fields: {
    all: {
      style: {
        fontFamily: 'Proxima+Nova',
        fontSize: '14px',
        fontColor: '#1395f0',
        fontWeight: '400',
      },
    },
  },
};

export const USAGE_EXPERIMENT_NAME = 'web-ui-usage-based-billing';
export const USAGE_AVAILABLE_PRODUCTS = Object.freeze({
  VIRTUAL: [
    // Object.freeze({
    //   name: 'Linux Container',
    //   rate: 16,
    //   config: 'Headless, 2 CPU',
    // }),
    Object.freeze({
      name: 'Windows PCs',
      rate: 16,
      config: 'Placeholder',
    }),
    Object.freeze({
      name: 'macOS',
      rate: 30,
      config: 'Placeholder',
    }),
    Object.freeze({
      name: 'Android Emulators',
      rate: 40,
      config: 'Placeholder',
    }),
    Object.freeze({
      name: 'iOS Simulators',
      rate: 40,
      config: 'Placeholder',
    }),
  ],
  REAL: [
    Object.freeze({
      name: 'Android Smartphones & Tablets',
      rate: 75,
      config: 'Placeholder',
    }),
    Object.freeze({
      name: 'iOS Smartphones & Tablets',
      rate: 75,
      config: 'Placeholder',
    }),
  ],
});

// Product amount keys
export const CONCURRENCY_KEY = 'concurrency';
export const INTERVAL_KEY = 'interval';
export const PROJECTS_KEY = 'projects';
export const CREDIT_BLOCKS_KEY = 'creditBlocks';

// Maps to plan.device_type
export const VIRTUAL_DEVICE = 'virtual';
export const REAL_DEVICE = 'real';

export const VIRTUAL_CLOUD_DEVICE_LABEL = 'Virtual Devices';
export const REAL_DEVICE_LABEL = 'Real Devices';
export const DEVICE_TYPE_TO_LABEL = {
  [VIRTUAL_DEVICE]: VIRTUAL_CLOUD_DEVICE_LABEL,
  [REAL_DEVICE]: REAL_DEVICE_LABEL,
};

export const PLAN_INTERVAL = {
  MONTH: 'month',
  YEAR: 'year',
  WEEK: 'week',
};

export const PLAN_CODE_INTERNVAL = {
  MONTHLY: 'monthly',
  ANNUAL: 'annual',
  WEEKLY: 'weekly',
};

export const INTERVAL_TO_LABEL = {
  [PLAN_CODE_INTERNVAL.MONTHLY]: 'Monthly',
  [PLAN_CODE_INTERNVAL.ANNUAL]: 'Annual',
  [PLAN_CODE_INTERNVAL.WEEKLY]: 'Weekly',
  [PLAN_INTERVAL.MONTH]: 'Monthly',
  [PLAN_INTERVAL.YEAR]: 'Annual',
  [PLAN_INTERVAL.WEEK]: 'Weekly',
};

export const PRODUCT_LIVE = 'live';
export const PRODUCT_RDC = 'rdc';
export const PRODUCT_VDC = 'vdc';
export const PRODUCT_AUTOMATED = 'automated';
export const PRODUCT_MOBILE_QUALITY = 'mobile-quality';
export const PRODUCT_API_TESTING = 'api-testing';
export const PRODUCT_USAGE = 'usage';

// api-testing in recurly has one paid plan
export const ADDON_PROJECTS_PAID_THRESHOLD = 6;

export const ADDON_PARALLEL_TESTS = 'parallel-tests';
export const ADDON_PROJECTS = 'projects';
export const ADDON_CREDIT_BLOCKS = 'credit-blocks';
export const ADDON_CODES = [ADDON_PARALLEL_TESTS, ADDON_PROJECTS, ADDON_CREDIT_BLOCKS];

export const TIERED = 'tiered';
export const STAIRSTEP = 'stairstep';
export const FLAT = 'flat';

export const TOPUP_SOURCES = {
  AUTO: 'automatic_refill',
  NEW_SUBSCRIPTION: 'new_subscription',
  RENEWAL: 'subscription_renewal',
  UPGRADE: 'subscription_upgrade',
};

// They're defined in Recurly plan description field as a `testing_type`
export const TESTING_TYPES: { [key: string]: TestingType } = {
  LIVE: 'live',
  AUTOMATED_LIVE: 'automated_live',
  MOBILE_QUALITY: 'mobile_quality',
  API_TESTING: 'api_testing',
  USAGE: 'usage',
};

export const PRODUCT_LABELS = {
  API_TESTING: 'API Testing',
  AUTOMATED_LIVE: 'Automated + Live',
  LIVE: 'Live Testing',
  MOBILE_QUALITY: 'Mobile Beta Testing - TestFairy',
  REAL_DEVICE: 'Mobile App',
  USAGE: 'Automated + Live (credits-based)',
};

// We want to display label instead of testing type to the user
export const TESTING_TYPE_TO_LABEL = {
  [TESTING_TYPES.API_TESTING]: PRODUCT_LABELS.API_TESTING,
  [TESTING_TYPES.AUTOMATED_LIVE]: PRODUCT_LABELS.AUTOMATED_LIVE,
  [TESTING_TYPES.LIVE]: PRODUCT_LABELS.LIVE,
  [TESTING_TYPES.MOBILE_QUALITY]: PRODUCT_LABELS.MOBILE_QUALITY,
  [TESTING_TYPES.USAGE]: PRODUCT_LABELS.USAGE,
};

export const MOBILE_QUALITY_LABEL = 'Mobile Beta Testing - TestFairy';
export const MOBILE_QUALITY_TIER = 'Startup';

export const TESTING_TYPE_TO_TIER = {
  [TESTING_TYPES.AUTOMATED_LIVE]: PRODUCT_LABELS.AUTOMATED_LIVE,
  [TESTING_TYPES.LIVE]: PRODUCT_LABELS.LIVE,
  [TESTING_TYPES.MOBILE_QUALITY]: MOBILE_QUALITY_TIER,
};

export const SUBSCRIPTION_STATE = {
  ACTIVE: 'active',
  CANCELED: 'canceled',
};

export const ALLOWED_CONCURRENCY_VALUES = [
  0, 1, 2, 3, 4, 5, 6, 8, 10, 12, 14, 16, 20, 24,
];
export const ALLOWED_PROJECTS_VALUES = [6, 7, 8, 9, 10, 11, 12];
export const ALLOWED_CREDIT_BLOCK_VALUES = Object.freeze({
  [PLAN_INTERVAL.MONTH]: [1, 2, 3, 4, 5, 6, 7, 8],
  [PLAN_INTERVAL.YEAR]: [12, 24, 36, 48, 60, 72, 84, 96],
});
export const CREDITS_PER_BLOCK = 25000;
export const ANNUAL_BONUS_PERCENTAGE = 0.1;

export const CONCURRENCY_LABELS: {[key in ProductType]: string} = {
  [PRODUCT_LIVE]: 'Parallel Tests',
  [PRODUCT_VDC]: 'Virtual Devices',
  [PRODUCT_RDC]: 'Real Devices',
  [PRODUCT_MOBILE_QUALITY]: '',
  [PRODUCT_API_TESTING]: 'Projects',
  [PRODUCT_USAGE]: 'Credits',
};

export const UNIFIED_BILLING_TYPE = 'unified_billing';
export const USAGE_TYPE = 'usage';

export const PLAN_TYPE_TO_PRODUCT_KEY = {
  [PRODUCT_API_TESTING]: PROJECTS_KEY,
  [PRODUCT_LIVE]: CONCURRENCY_KEY,
  [PRODUCT_MOBILE_QUALITY]: CONCURRENCY_KEY,
  [PRODUCT_RDC]: CONCURRENCY_KEY,
  [PRODUCT_USAGE]: CREDIT_BLOCKS_KEY,
  [PRODUCT_AUTOMATED]: CONCURRENCY_KEY,
  [PRODUCT_VDC]: CONCURRENCY_KEY,
};

// BILLING "SUCCESS" MESSAGES:
export const SUCCESS_STEP_TITLE_SUCCESS = 'Success';
export const SUCCESS_STEP_TITLE_CANCEL = '{device_type} Subscription Canceled!';
export const SUCCESS_STEP_DESC_LEVEL_UP = 'You’ve just leveled up! You have successfully updated your Sauce Labs coverage! Please check your email for confirmation of your plan changes.';
export const SUCCESS_STEP_DESC_UPDATED_COVERAGE = 'You have successfully updated your Sauce Labs coverage! Please check your email for confirmation of your plan changes.';
export const SUCCESS_STEP_DESC_CANCEL = 'We’re sorry to see you go! Cancellations take place at the end of the billing cycle. You may continue to use Sauce Labs until {billing_cycle_date}. Your account will remain in read-only mode after cancellation. Thanks for being a Sauce Labs customer. If there is anything we can do to help, please give us a call at: 1-855-677-0011';

// SUCCESS TYPES VALUES
export const NEW_PURCHASE = 'new purchase';
export const UPGRADE = 'upgrade';
export const DOWNGRADE = 'downgrade';
export const LEGACY = 'legacy';
export const CANCEL = 'cancel';

// SUCCESS TYPES
export const SUCCESS_TYPES = [
  NEW_PURCHASE,
  UPGRADE,
  DOWNGRADE,
  LEGACY,
  CANCEL,
];

export const API_DATE_FORMAT = 'yyyy-MM-dd';
export const MOMENT_FORMAT_DAY_MONTH_YEAR = 'LL';
export const MOMENT_FORMAT_ORDINAL_DAY_OF_MONTH = 'Do';
export const CREDITS_EXPIRY_FORMAT = 'MMM dd';
export const CREDITS_EXPIRY_ANNUAL_FORMAT = 'MMM dd y';
export const NEXT_BILL_DATE_FORMAT = 'MMM d, yyyy';
export const INVOICES_DATE_FORMAT = 'dd MMM yyy';

export const PENDING_INVOICE_STATE = 'pending';
export const PROCESSING_INVOICE_STATE = 'processing';
export const PAST_DUE_INVOICE_STATE = 'past_due';
export const PAID_INVOICE_STATE = 'paid';
export const FAILED_INVOICE_STATE = 'failed';

export const SUCCESS_FLYING_IMAGE_WIDTH = 498;
export const SUCCESS_FLYING_IMAGE_HEIGHT = 353;
export const SUCCESS_CANCEL_IMAGE_WIDTH = 230;
export const SUCCESS_CANCEL_IMAGE_HEIGHT = 375;
export const SUCCESS_ADJUSTING_IMAGE_WIDTH = 299;
export const SUCCESS_ADJUSTING_IMAGE_HEIGHT = 382;

export const INVALID_ADDRESS_ERROR_TYPE = 'invalid_address';

export const SALES_CONTACT_NUMBER = '+14159461120';
export const SALES_CONTACT_NUMBER_READABLE = '+1 (415) 946-1120';
export const SALES_CONTACT_EMAIL = 'billing@saucelabs.com';
export const SALES_CONTACT_FORM = 'https://saucelabs.com/sales';

export const PURCHASE_SUCCESS_MODAL = 'purchaseSuccessModal';
export const CANCEL_SUBSCRIPTION_SURVEY_MODAL = 'cancelSubscriptionSurveyModal';
export const CROSS_BROWSER_FEATURES_MODAL = 'crossBrowserFeaturesModal';
export const NUDGE_ANNUAL_PLAN_MODAL = 'nudgeAnnualPlanModal';
export const PAYMENT_QUESTIONNAIRE_MODAL = 'paymentQuestionnaireModal';
export const API_TESTING_COMPARISON_MODAL = 'apiTestingPlanCompareModal';
export const MOBILE_QUALITY_COMPARISON_MODAL = 'testFairyPlanCompareModal';
export const TESTFAIRY_TERMS_MODAL = 'testfairyTermsModal';
export const CREDITS_AUTO_TOPUP_MODAL = 'creditsAutoTopupModal';

export const TRANSACTION_ERROR_TYPE = 'transaction';
export const THREEDS_AUTH_ERROR_TYPE = '3ds-auth-error';
export const THREEDS_FAILURE_MESSAGE = 'We were unable to authenticate your payment method. Please check your card details and try again.';

export const STICKY_SUMMARY_OFFSET = 64;

export const NOTIFICATION_ID_ERROR_FORM_DATA = 'notification-billing-unified-error-form';
export const NOTIFICATION_ID_ERROR_PURCHASE = 'notification-billing-unified-error-checkout';

// ANIMATIONS
export const JUMP_FADE = {
  initial: { opacity: 0, y: -30 },
  animate: { opacity: 1, y: 0 },
  exit: { opacity: 0, y: 30 },
};

export const FADE = {
  initial: { opacity: 0 },
  animate: { opacity: 1 },
  exit: { opacity: 0 },
};

export const TRANSITION = { duration: 0.2, ease: [0.6, 0.01, -0.05, 0.9] };
export const EMAIL_SUPPORT_PLAN_UPDATE = 'update';

const shuffle = (array) => {
  let currentIndex = array.length;
  let randomIndex;

  if (currentIndex > 1) {
    // While there remain elements to shuffle.
    while (currentIndex !== 0) {
      // Pick a remaining element.
      randomIndex = Math.floor(Math.random() * currentIndex);
      currentIndex -= 1;

      // And swap it with the current element.
      // eslint-disable-next-line no-param-reassign
      [array[currentIndex], array[randomIndex]] = [
        array[randomIndex], array[currentIndex]];
    }
  }

  // eslint-disable-next-line @typescript-eslint/no-unsafe-return
  return array;
};

// cancellation subscription survey questions
const REASON_OPTIONS_LIST = [
  'It’s too difficult to use',
  'It doesn’t have the features or integrations I expected',
  'It’s too expensive',
  'I’m dissatisfied with the product performance',
  'I no longer need testing',
  'My project has finished',
];

const TESTING_OPTIONS_LIST = [
  'BrowserStack',
  'Cypress',
  'SmartBear',
  'Katalon',
  'LambdaTest',
  'Applitools',
  'Testing internally',
];

export const SURVEY_QUESTIONS = [{
  key: 'survey-question-1',
  question: 'Why are you canceling your subscription?',
  answerList: shuffle(REASON_OPTIONS_LIST).map((option) => ({
    label: option,
    value: option,
  })).concat([{
    label: 'Other',
    value: 'Other',
  }]),
},
{
  key: 'survey-question-2',
  question: 'What will you use for testing now?',
  answerList: shuffle(TESTING_OPTIONS_LIST).map((option) => ({
    label: option,
    value: option,
  })).concat([{
    label: 'Other',
    value: 'Other',
  }, {
    label: 'Nothing / Unsure',
    value: 'Nothing / Unsure',
  }]),
},
];

// UsageDetails charts
export const DEVICES = Object.freeze({
  virtual_devices: [
    {
      key: 'linux_virtual_machine',
      friendlyName: 'Linux Container',
    },
    {
      key: 'windows_virtual_machine',
      friendlyName: 'Windows PCs',
    },
    {
      key: 'mac_virtual_machine',
      friendlyName: 'macOS',
    }, {
      key: 'android_virtual_machine',
      friendlyName: 'Android Emulators',
    },
    {
      key: 'ios_virtual_machine',
      friendlyName: 'iOS Simulators',

    },
  ],
  real_devices: [
    {
      key: 'android_real_device',
      friendlyName: 'Android Devices',
    },
    {
      key: 'ios_real_device',
      friendlyName: 'iOS Devices',
    },
  ],
});

const FLATTEN_DEVICES = Object.values(DEVICES)
  .reduce((acc, curVal) => acc.concat(curVal), []);

export const DEVICES_KEYS = FLATTEN_DEVICES.map((obj) => obj.key);

export const DEVICE_NAME_MAP = Object.assign(
  {},
  ...FLATTEN_DEVICES.map((obj) => ({ [obj.key]: obj.friendlyName })),
);

export const DEVICE_COLOR_MAP = Object.freeze({
  android_real_device: '#005D5D',
  android_virtual_machine: '#009D9A',
  ios_real_device: '#6929C4',
  ios_virtual_machine: '#A56EFF',
  mac_virtual_machine: '#002D9C',
  windows_virtual_machine: '#1192E8',
});

export const FREEMIUM_CREDITS_REFILL_AMOUNT = 2000;
